import styled, { css } from 'styled-components';

export const StyledSortContainer = styled.div`
    display: flex;
    padding: 0 ${({theme}) => theme.spacing.m};
`;

export const SortingContainer = styled.div(
  ({width}) => css`
      display: flex;
      width: ${width};
  `
);

export const StyledSortIcon = styled.div`
    margin-left: ${({theme}) => theme.spacing.xs};
`;

export const SortLabel = styled.div`
    font: inherit;
    font-size: ${({theme}) => theme.fontSize.xs};
    font-weight: ${({theme}) => theme.fontWeight.semiBold};
    align-self: center;
`;
